/**
 * First we will load all of this project's JavaScript dependencies which
 * include Vue and Vue Resource. This gives a great starting point for
 * building robust, powerful web applications using Vue and Laravel.
 */

import './bootstrap';
import './bootstrap/echo';
import './bootstrap/laroute';
import './bootstrap/sentry';
import './bootstrap/vuex';
import './bootstrap/ziggy';

import 'eonasdan-bootstrap-datetimepicker';

import './directives/click-outside';
import './plugins/parsleyjs';
import './plugins/global-event-bus';
import './plugins/vuetable';
import './plugins/toastr';

import './components';
import './franchise_component';

import router from './router';

import Vue from 'vue';
import VuePapaParse from 'vue-papa-parse';
import CircularCountDownTimer from 'vue-circular-count-down-timer';
import ECharts from 'vue-echarts';
import store from './store';
import Multiselect from 'vue-multiselect';
import VeeValidate from 'vee-validate';
import InfiniteLoading from 'vue-infinite-loading';
import { VueEditor } from 'vue2-editor';
import VueClipboard from 'vue-clipboard2';
import VueTheMask from 'vue-the-mask';
import VueTable2Checkbox from './plugins/vuetable2-checkbox';
import { Pagination } from 'vue-pagination-2';

import mixins from './mixins';
import LangMixin from './mixins/lang';
import LaravelErrorMixin from './mixins/validator-laravel-error';
import LoadingMixin from './mixins/loading';
import swalMixin from './mixins/swal';
import SubscriptionMixin from './mixins/subscription';
import Swatches from 'vue-swatches';
import draggable from 'vuedraggable';
import VueTimeago from 'vue-timeago';
import VTooltip from 'v-tooltip';
import parsleyMixin from './mixins/parsley';
import Inview from 'vueinview';
import InputColorPicker from 'vue-native-color-picker';

/* vue-echarts v4 removed echarts dependencies so need to install and import manually */
import 'echarts';
import 'echarts-liquidfill';
import VJstree from 'vue-jstree';

let inProduction = process.env.NODE_ENV === 'production';

Vue.config.debug = !inProduction;
Vue.config.devtools = !inProduction;

Vue.prototype.$http = window.axios;

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the body of the page. From here, you may begin adding components to
 * the application, or feel free to tweak this setup for your needs.
 */

/** Form Validation for vue js **/
Vue.use(VeeValidate);
Vue.use(VueTable2Checkbox);
Vue.use(VuePapaParse);
Vue.use(VTooltip);
Vue.mixin(mixins);
Vue.mixin(LangMixin);
Vue.mixin(LaravelErrorMixin);
Vue.mixin(LoadingMixin);
Vue.mixin(SubscriptionMixin);
Vue.mixin(swalMixin);
Vue.mixin(parsleyMixin);

Vue.use(VueTheMask);
Vue.use(VueClipboard);
Vue.use(VueTimeago, { locale: 'en' });
Vue.use(Inview);
Vue.use(InputColorPicker);
Vue.use(VJstree);
Vue.use(CircularCountDownTimer);

// set autohide when click outside of popover to false
VTooltip.options.popover.defaultAutoHide = false;

Vue.component('vue-draggable', draggable);
Vue.component('chart', ECharts);
Vue.component('vue-swatches', Swatches);

/** Vue WYSIWYG Editor */
Vue.component('vue-editor', VueEditor);

Vue.component('pagination', Pagination);

/** Vue Select 2 **/
Vue.component('multiselect', Multiselect);
Vue.component('infinite-loading', InfiniteLoading);

Vue.directive('focus', {
    inserted: function(el) {
        el.setAttribute('autofocus', true);
        el.focus();
    },
});

const options = {
    el: '#app',
    store,
};

// load vue routes if global vueRoutes variable exists
if (window.vueRoutes !== undefined) {
    options['router'] = router(window.vueRoutes);
}

const app = new Vue(options);
